import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
export interface List {
  /** 设备类型 0-未知, 1-U盘, 2-便携式设备 */
  peripheral_type: number
  /** 设备类型名称 */
  type_name: string
  /** 数量 */
  count: number
}

export interface ResponseData {
  /** 今日接入次数 */
  today_access_count: number
  /** 待审批申请数 */
  pending_approval_count: number
  /** 已接入USB设备数 */
  connected_device_count: number
  /** 设备类型分布 */
  list: List[]
}
@Injectable()
export default class UsbStatisticsService {
  constructor (private http: Http) {
  }
  getPeripheralcontrolOverviewGet () {
    return this.http.post<ResponseData>('/peripheralcontrol/overview/get', {})
  }
}
